import { onMounted, onUnmounted, ref } from "vue";

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
};

export function useInstallPrompt() {
  const installPrompt = ref<BeforeInstallPromptEvent | null>(null);

  function onBeforeInstallPrompt(event: Event) {
    event.preventDefault();
    installPrompt.value = event as BeforeInstallPromptEvent;
  }

  async function promptInstall() {
    if (!installPrompt.value) {
      return;
    }

    await installPrompt.value.prompt();
    await installPrompt.value.userChoice.catch(() => undefined);
    installPrompt.value = null;
  }

  onMounted(() => {
    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
  });

  onUnmounted(() => {
    window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
  });

  return {
    canInstall: installPrompt,
    promptInstall
  };
}
